import { TextField } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import "./inputs.css";

const DefaultInput = ({
  label,
  value,
  onChange,
  disabled = false,
  type = undefined,
  error = false,
  helperText = "",
  required = false,
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      className={"default__input"}
      onChange={(event) => onChange(event.target.value)}
      label={t(label)}
      value={value}
      disabled={disabled}
      type={type}
      error={Boolean(error)}
      helperText={helperText ? t(helperText) : undefined}
      required={required}
    />
  );
};

export default DefaultInput;
